import type {
  IControlSelectCompound,
  IControlSelectDropdown,
  IControlSelectInline,
  IControlSelectBase,
} from '~/presentation/reports/ui';
import type {
  CompoundSelectSettingType,
  SelectOptionType,
  SelectValueType,
} from '~/presentation/reports/ui/type';
import type { IControlSelectCampaignItem } from '~/presentation/reports/ui/SelectCampaignItem';
import type { IControlSelectCampaign } from '~/presentation/reports/ui/SelectCampaign';
import type { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import type { IControlSectionCard } from '~/presentation/reports/ui/SectionCard';
import type { IControlSelectPage } from '~/presentation/reports/ui/SelectPage';
import type { IRItemCard } from '../../type';

export enum EControlType {
  SELECT_INLINE = 'SelectInline',
  SELECT_DROPDOWN = 'SelectDropdown',
  SELECT_COMPOUND = 'SelectCompound',
  SECTION_CARD = 'SectionCard',
  SELECT_PAGE = 'SelectPage',
  SELECT_CAMPAIGN = 'SelectCampaign',
  SELECT_CAMPAIGN_ITEM = 'SelectCampaignItem',
  SELECT_BASE = 'SelectBase',
}

export enum EDependentControlAction {
  DISABLE = 'disable',
  HIDE = 'hide',
}

export interface IDependentControl {
  id: string;
  value?: SelectValueType;
  action?: EDependentControlAction;
  tooltip?: {
    content: string;
  };
}

export interface IDraggableControl {
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  isDragging: boolean;
}

export interface IBaseControlSetting<TValue = SelectValueType> {
  id: string;
  uid?: string;
  label?: string;
  defaultValue?: TValue;
  options?: SelectOptionType[];
  width?: string;
  configs?: CompoundSelectSettingType[];
  disabled?: boolean;
  hide?: boolean;
  controls?: IControlSettingUI[];
  condition?: string;
  connector?: {
    options?: IControlSettingUI['id'];
    key: string;
    value?: string | string[];
  };
  draggable?: IDraggableControl;
  dependentControls?: IDependentControl[];
  info?: IRItemCard;
}

export type IControlSettingUI =
  | IControlSelectInline
  | IControlSelectDropdown
  | IControlSelectCompound
  | IControlSectionCard
  | IControlSelectPage
  | IControlSelectCampaign
  | IControlSelectCampaignItem
  | IControlSelectBase;

export type IControlSettingValue = {
  value?: SelectValueType;
  defaultTab?: string;
};

export type ControlSettingStateType = Record<string, { hide: boolean; disabled: boolean }>;

export type IControlSettingData = Record<string, IControlSettingValue>;

export type IDynamicControlSetting = Record<
  string,
  { controls: IControlSettingUI[]; config?: IControlSectionCard['config'] }
>;
